import { isNavigationFailure, NavigationFailureType } from "vue-router";
import router from "@/routes";

const publicPaths = [
    "/login",
    "/reset-password",
    "/request-reset-password",
    "/new-user-set-password",
    "/sign-up",
    "/accept-invitation",
    "/sso-onboard-token",
    "/terms-and-conditions",
    "/privacy-policy",
];

export function currentRouteIsPublic() {
    return routeIsPublic(router.currentRoute);
}

export function routeIsPublic(route) {
    return publicPaths.some(publicPath =>
        publicPath == route.path
    );
}

export function goTo(path) {
    if (router.currentRoute.path !== path) {
        // A navigation guard redirecting elsewhere (e.g. to 2FA or SSO onboarding) is expected,
        // not an error.
        router.push(path).catch(error => {
            if (!isNavigationFailure(error, NavigationFailureType.redirected)) {
                throw error;
            }
        });
    }
}

// Only same-origin relative paths are allowed as a redirect destination - rejects absolute URLs and
// protocol-relative ("//host/...") or backslash-prefixed paths that browsers will still treat as a
// redirect to another host. Used anywhere a server-supplied or query-string returnUrl is consumed
// before actually navigating to it (SSO callback, post-login redirects).
export function isSafeReturnUrl(url) {
    if (!url || typeof url !== "string") {
        return false;
    }

    if (url.startsWith("//") || url.startsWith("\\")) {
        return false;
    }

    try {
        // A relative path like "/reports" throws when parsed alone; only reject it if the browser
        // can resolve it into a URL pointing at a different origin.
        const resolved = new URL(url, window.location.origin);
        return resolved.origin === window.location.origin;
    } catch {
        return false;
    }
}

export default {
    goTo,
    routeIsPublic,
    currentRouteIsPublic,
    isSafeReturnUrl
};
